import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from './Loading';

const PageTransition = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Sayfa değiştiğinde loading'i göster
    setIsLoading(true);
    
    // Scroll'u en üste al
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Hızlı scroll
    });

    // Loading süresini simüle et (600ms)
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="page-transition-wrapper">
      {children}
    </div>
  );
};

export default PageTransition; 